import firebase from 'firebase/app';

import { ROUTER_PATHS } from '../constants';

let user = firebase.auth().currentUser;
let initPhase = new Promise((resolve) => {
  firebase.auth().onAuthStateChanged((u) => {
    user = u;
    resolve();
    initPhase = false;
  });
});

export default function authGuard(to, from, next) {
  if (initPhase) {
    return initPhase.then(() => authGuard(to, from, next));
  }

  if (user && to.path === ROUTER_PATHS.LOGIN) {
    return next(ROUTER_PATHS.ACCOUNT);
  }

  if (!user && to.meta.safe) {
    return next(ROUTER_PATHS.LOGIN);
  }

  return next();
}
